<template>
  <v-container class="p-insure px-0">
    <v-layout row class="mt-2">
      <v-flex grow>
        <!-- 投保 -->
        <CSection title="投保" class="insure-card">
          <h3>企业复工综合保险</h3>
          <v-form ref="form" lazy-validation class="form">
            <!-- 基本信息 -->
            <section class="form-section">
              <p class="mb-4">基本信息</p>
              <div class="form-item">
                <label>投保资料</label>
                <CUpload
                  class="form-item-btn-wrap"
                  :on-success="onUploadSuccess"
                  accept="pdf"
                  :limit="1"
                >上传投保资料</CUpload>
                <v-btn :href="templateUrl" color="primary" flat>下载模板</v-btn>
              </div>
              <v-flex class="form-item form-item-left">
                <label>投保情况</label>
                <v-radio-group v-model="info.policySituation" style="margin-top:0;">
                  <v-radio label="新保" value="新保"></v-radio>
                  <v-radio label="续保" value="续保"></v-radio>
                  <v-text-field
                    v-model="info.policyNo"
                    :solo="solo"
                    :rules="rules.info.policyNo"
                    placeholder="上年保单号"
                    v-if="info.policySituation === '续保'"
                  ></v-text-field>
                </v-radio-group>
              </v-flex>
            </section>
            <hr class="line" />
            <!-- 投保人信息 -->
            <section class="form-section">
              <p class="mb-4">投保人信息</p>
              <v-flex class="form-item">
                <label>客户名称</label>
                <v-text-field
                  placeholder="请输入客户名称"
                  v-model="applicant.name"
                  :solo="solo"
                  :rules="rules.applicant.name"
                  label
                ></v-text-field>
              </v-flex>
              <v-flex class="form-item">
                <label>联系邮箱</label>
                <v-text-field
                  placeholder="请输入联系邮箱"
                  v-model="applicant.email"
                  :solo="solo"
                  :rules="rules.applicant.email"
                  label
                ></v-text-field>
              </v-flex>
              <v-flex class="form-item">
                <label>统一社会信用代码</label>
                <v-text-field
                  placeholder="请输入统一社会信用代码"
                  v-model="applicant.identifyNumber"
                  :solo="solo"
                  :rules="rules.identifyNumber"
                  label
                ></v-text-field>
              </v-flex>
              <v-layout>
                <v-flex class="form-item form-item-left">
                  <label>地址</label>
                  <v-text-field
                    v-model="applicant.address"
                    :solo="solo"
                    :rules="rules.applicant.address"
                    placeholder="请填写详细地址"
                  ></v-text-field>
                </v-flex>
                <v-flex class="form-item">
                  <label>邮政编码</label>
                  <v-text-field
                    v-model="applicant.postCode"
                    :solo="solo"
                    :rules="rules.applicant.postCode"
                    placeholder="请填写邮政编码"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="form-item form-item-left">
                  <label>联系人姓名</label>
                  <v-text-field
                    v-model="applicant.contactName"
                    :solo="solo"
                    :rules="rules.contactName"
                    placeholder="请填写联系人姓名"
                  ></v-text-field>
                </v-flex>
                <v-flex class="form-item">
                  <label>联系电话</label>
                  <v-text-field
                    v-model="applicant.contantMobile"
                    :solo="solo"
                    :rules="rules.contantMobile"
                    placeholder="请填写联系电话"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </section>
            <!-- 被保险人信息 -->
            <section class="form-section">
              <p class="mb-4">被保险人信息</p>
              <v-flex class="form-item">
                <label>客户名称</label>
                <v-text-field
                  placeholder="请输入客户名称"
                  v-model="insured.name"
                  :solo="solo"
                  :rules="rules.insured.name"
                  label
                ></v-text-field>
              </v-flex>
              <v-flex class="form-item">
                <label>统一社会信用代码</label>
                <v-text-field
                  placeholder="请输入统一社会信用代码"
                  v-model="insured.identifyNumber"
                  :solo="solo"
                  :rules="rules.identifyNumber"
                  label
                ></v-text-field>
              </v-flex>
              <v-layout>
                <v-flex class="form-item form-item-left">
                  <label>地址</label>
                  <v-text-field
                    v-model="insured.address"
                    :solo="solo"
                    :rules="rules.insured.address"
                    placeholder="请填写详细地址"
                  ></v-text-field>
                </v-flex>
                <v-flex class="form-item">
                  <label>邮政编码</label>
                  <v-text-field
                    v-model="insured.postCode"
                    :solo="solo"
                    :rules="rules.insured.postCode"
                    placeholder="请填写邮政编码"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="form-item form-item-left">
                  <label>联系人姓名</label>
                  <v-text-field
                    v-model="insured.concatName"
                    :solo="solo"
                    :rules="rules.contactName"
                    placeholder="请填写联系人姓名"
                  ></v-text-field>
                </v-flex>
                <v-flex class="form-item">
                  <label>联系电话</label>
                  <v-text-field
                    v-model="insured.mobile"
                    :solo="solo"
                    :rules="rules.contantMobile"
                    placeholder="请填写联系电话"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </section>
            <!-- 投保信息 -->
            <section class="form-section">
              <p class="mb-4">投保人信息</p>
              <v-flex class="form-item">
                <label>被保险财产坐落地址</label>
                <v-text-field
                  placeholder="请填写被保险财产坐落详细地址，如存在多个地址，请使用分号隔开"
                  v-model="insured.propertyAddress"
                  :solo="solo"
                  :rules="rules.insured.propertyAddress"
                  label
                ></v-text-field>
              </v-flex>
              <v-flex class="form-item">
                <label>营业性质</label>
                <v-text-field
                  placeholder="请填写营业性质"
                  v-model="insured.businessNature"
                  :solo="solo"
                  :rules="rules.insured.businessNature"
                  label
                ></v-text-field>
              </v-flex>
              <v-flex class="form-item">
                <label>行业</label>
                <v-text-field
                  placeholder="请填写行业"
                  v-model="insured.industry"
                  :solo="solo"
                  :rules="rules.insured.industry"
                  label
                ></v-text-field>
              </v-flex>
              <v-flex class="form-item">
                <label>被保险人企业性质</label>
                <v-radio-group v-model="insured.enterpriseNature">
                  <v-radio label="机关" value="机关"></v-radio>
                  <v-radio label="事业单位" value="事业单位"></v-radio>
                  <v-radio label="社会团体" value="社会团体"></v-radio>
                  <v-radio label="企业" value="企业"></v-radio>
                  <v-radio label="国有" value="国有"></v-radio>
                  <v-radio label="集体" value="集体"></v-radio>
                  <v-radio label="三资" value="三资"></v-radio>
                  <v-radio label="私营" value="私营"></v-radio>
                  <v-radio label="其他" value=""></v-radio>
                  <v-text-field
                    v-model="insured.enterpriseNature"
                    :solo="solo"
                    :rules="rules.insured.enterpriseNature"
                    placeholder="其他"
                    v-if="insured.enterpriseNature === ''"
                  ></v-text-field>
                </v-radio-group>
              </v-flex>
            </section>
            <!-- 方案信息 -->
            <section class="form-section">
              <p class="mb-4">方案信息</p>
              <v-flex class="form-item form-item-left">
                <label>主险</label>
                <v-radio-group v-model="info.mainRisk" style="margin-top:0;">
                  <v-radio :label="item.gp" :value="item.gp" v-for="(item,index) in plan.mainRisk" :key="index"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex class="form-item">
                <label>主险方案内容</label>
                <span class="text">{{mainDes}}</span>
              </v-flex>
              <v-flex class="form-item form-item-left">
                <label>附加传染病营业中断保险</label>
                <v-radio-group v-model="info.planId"  v-if="plan.lists">
                  <v-radio :label="item.gp" :value="item.gp"  v-for="(item,index) in plan.lists.items" :key="index"></v-radio>
                </v-radio-group>
              </v-flex>
               <v-flex class="form-item form-item-left">
                <label style="width:310px">附加险方案内容</label>
                <span class="text mb-4">{{planDes}}</span>
              </v-flex>
              <v-flex class="form-item form-item-left">
                <label>保险期限开始时间</label>
                <v-menu
                  ref="dateMenu"
                  v-model="effectStartDateMenuVisible"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    placeholder="请选择保险期限开始时间"
                    slot="activator"
                    class="date-input"
                    v-model="info.startDate"
                    :solo="solo"
                    :rules="rules.info.startDate"
                    append-icon="calendar_today"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="info.startDate"
                    :header-date-format="date=>date"
                    no-title
                    @input="effectStartDateMenuVisible = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex class="form-item form-item-left" v-show="info.startDate">
                <label>保险期限结束时间</label>              
                  <v-text-field
                    slot="activator"
                    class="date-input"
                    v-model="endDate"
                    :solo="solo"
                    append-icon="calendar_today"
                    readonly
                  ></v-text-field>
              </v-flex>
              <v-flex class="form-item">
                <label>月数</label>
                <v-text-field
                  placeholder="请填写月数"
                  v-model="info.mainRisk"
                  :solo="solo"
                  label
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex class="form-item">
                <label>总保险费</label>
                <v-text-field
                  placeholder="请填写总保险费"
                  v-model="price"
                  :solo="solo"
                  :rules="rules.info.amount"
                  label
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex class="form-item form-item-left">
                <label>缴费计划</label>
                <v-radio-group v-model="info.payPeriod" style="margin-top:0;">
                  <v-radio label="一次缴清" value="1"></v-radio>
                  <v-radio label="分期缴清，请具体说明缴费计划" value=""></v-radio>
                  <v-text-field
                    v-model="info.payPeriodExplain"
                    :solo="solo"
                    :rules="rules.info.payPeriodExplain"
                    placeholder="请输入缴费计划"
                    v-if="info.payPeriod === ''"
                  ></v-text-field>
                </v-radio-group>
              </v-flex>
              <v-flex class="form-item form-item-left">
                <label>保险标的是否向其他保险公司投保同类保险</label>
                <v-radio-group v-model="info.isFlag" style="margin-top:0;">
                  <v-radio label="否" value="2"></v-radio>
                  <v-radio label="是，请具体说明保险状况" value="1"></v-radio>
                  <v-text-field
                    v-model="info.flagExplain"
                    :solo="solo"
                    :rules="rules.info.flagExplain"
                    placeholder="请输入保险状况"
                    v-if="info.isFlag === '1'"
                  ></v-text-field>
                </v-radio-group>
              </v-flex>
            </section>
          </v-form>
        </CSection>
      </v-flex>
      <v-flex shrink class="right-section">
        <div v-pin="{padding: {top: 136}}" class="pay-card block">
          <div>
            总保费
            <span class="display-1 primary-text">￥{{price}}</span>
          </div>
          <hr class="line">
          <v-layout>
            <v-flex shrink>
              <v-checkbox v-model="agree" class="checkbox" label></v-checkbox>
            </v-flex>
            <v-flex>
              我已仔细阅读且确认《
              <a class="primary-text" @click="noticeVisible=true">投保须知及声明</a>》
            </v-flex>
          </v-layout>
          <v-btn
            class="pay-btn"
            :disabled="!agree"
            :loading="loading"
            color="primary"
            block
            @click="onPay"
          >去投保</v-btn>
        </div>
      </v-flex>
    </v-layout>

    <Notice v-model="noticeVisible"></Notice>
    <TKDialog v-model="tkVisible" code="1075"></TKDialog>
  </v-container>
</template>

<script>
import Notice from "./components/ZFNotice";
import TKDialog from "./components/TKDialog";
import validate from "@/assets/js/validate";

export default {
  components:{
    Notice,
    TKDialog
  },
  props: {
    code: String
  },
  data() {
    return {
      solo: true,
      formValid: true,
      effectEndDateMenuVisible:false,
      effectStartDateMenuVisible:false,
      noticeVisible:false,
      agree: false,
      tkVisible:false,
      plan:[],
      // 基础信息
      info:{
        userId:"",
        channelId:"",
        productId:1075,
        startDate:"",
        endDate:"",
        insurancePeriod:"",//保障期限	
        insurancePeriodUnit:2, //保障期限单位：1-天，2-月，3-年,4-岁
        amount:"",//总保费
        hasAdditional:"", //是否有附加险呢 true false 
        mainRisk:"3个月",//主险 3个月 6个月
        mainRiskContent:"",//主险方案内容
        planId:"方案一",//附加传染病营业中断保险
        planContent:"", //附加险方案内容
        payPeriod:"1",//缴费计划 一次交情传1 否则不传
        payPeriodExplain:"",//缴费计划 具体说明
        isFlag:"1",//保险标的是否向其他保险公司投保同类保险 1是 2否
        flagExplain:"",//保险标的是否向其他保险公司投保同类保险 是 说明
        policyPdfUrl:"",//pdf地址	
        policySituation:'新保',//新保 续保
        policyNo:"",//续保上年保单号	
        insuredAmount:""
      },
      // 投保人信息
      applicant:{
        name:'',
        identifyNumber:'',
        address:'',
        postCode:'',
        contactName:'',
        contantMobile:'',
        email:''
      },
      // 被保人信息
      insured:{
        name:'',
        identifyNumber:'',
        address:'',
        postCode:'',
        concatName:'',
        mobile:'',
        propertyAddress:'',//财产地址
        businessNature:'',//营业性质
        industry:'',//行业
        enterpriseNature:'机关'//企业性质
      },
      templateUrl:
        "https://qihuibao-group.oss-cn-beijing.aliyuncs.com/template/chac/%E7%8F%A0%E5%B3%B0%E5%A4%8D%E5%B7%A5%E7%BB%BC%E5%90%88%E4%BF%9D%E9%99%A9%E6%8A%95%E4%BF%9D%E5%8D%95.xls",
      rules: {
        identifyNumber:[v => {
          if (!v) {
            return "请输入投保人统一社会信用代码";
          }
          if (!validate.isUnifiedSocialCreditCode(v)) {
            return "请输入正确的投保人统一社会信用代码";
          }
          return true;
        }],
        contantMobile:[v => {
          if (!v) {
            return "请输入联系电话";
          }
          if (!validate.isMobilePhone(v)) {
            return "请输入正确的联系电话";
          }
          return true;
        }],
        contactName:[v => {
          if (!v) {
            return "请输入联系人姓名";
          }
          if (!validate.isChineseName(v)) {
            return "请输入联系人中文姓名";
          }
          return true;
        }],
        info:{
          policyNo: [v => !!v || "请输入续保上年保单号"],
          startDate:[v => !!v || "请输入保险期限开始时间"],
          amount:[v => !!v || "请输入总保险费"],
          payPeriodExplain:[v => !!v || "请输入缴费计划"],
          flagExplain:[v=>!!v||"请输入保险状况"]
        },
        applicant:{
          name:[v => !!v || "请输入投保人客户名称"],
          email:[v => {
            if (!v) {
              return "请输入投保人联系邮箱";
            }
            if (!validate.isEmail(v)) {
              return "请输入正确的投保人联系邮箱";
            }
            return true;
          }],
          address:[v => !!v || "请输入投保人地址"],
          postCode:[v => !!v || "请输入投保人邮政编码"]
        },
        insured:{
          name:[v => !!v || "请输入被保险人客户名称"],
          address:[v => !!v || "请输入被保险人地址"],
          postCode:[v => !!v || "请输入被保险人邮政编码"],
          propertyAddress:[v => !!v || "请输入被保险财产坐落地址"],//财产地址
          businessNature:[v => !!v || "请输入营业性质"],//营业性质
          industry:[v => !!v || "请输入行业"],//行业 
          enterpriseNature:[v=> !!v||'请输入被保险人企业性质']      
        }
      },
      loading: false
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo;
    },
    businessId() {
      return this.user && this.user.userId;
    },
    time(){
      let date = new Date();
      let hours=date.getHours();
      let minutes=date.getMinutes();
      let seconds=date.getSeconds();
      return hours+':'+minutes+':'+seconds;
    },
    mainItem() {
      return this.plan.mainRisk && this.plan.mainRisk.find(item => item.gp == this.info.mainRisk); 
    },
    mainPrice() {
      return this.plan.mainRisk && this.mainItem.price;
    },
    mainDes(){
      return this.plan.mainRisk && this.mainItem.des.replace("${price}", this.mainPrice);
    },
    planItem() {
      return this.plan.lists && this.plan.lists.items.find(item => item.gp == this.info.planId); 
    },
    planPrice() {
      const index = this.info.mainRisk === '3个月'? 0 : 1;
      return this.plan.lists && this.planItem.prices[index];
    },
    planDes() {
      return this.plan.lists && this.planItem.des.replace("${price}", this.planPrice).replace("${gp}",this.info.mainRisk);
    },
    price() {
      return (this.mainPrice+this.planPrice).toFixed(2);
    },
    month() {
      return parseInt(this.info.mainRisk);
    },
    endDate() {
      return this.info.startDate && this.$miment(this.info.startDate).add(this.month,'MM').format('YYYY-MM-DD');
    }
  },  
  methods: {
    onUploadSuccess(file) {
      this.info.policyPdfUrl = file.url;
    },
    onPay() {
      if (this.$refs.form.validate()) {
        if (!this.info.policyPdfUrl) {
          this.$message.error("请上传投保资料");
          return false;
        }
        this.info.userId = this.businessId;
        this.info.channelId = this.user.channelId;
        this.info.hasAdditional = this.info.planId !== "" ? true : false;
        this.info.startDate = this.info.startDate + ' '+this.time;
        this.info.endDate = this.endDate + ' '+this.time;
        this.info.insurancePeriod = this.month;
        this.info.amount = this.price;
        this.info.mainRiskContent = this.mainDes;
        this.info.planContent = this.planDes;
        const json = Object.assign({},{
           info:this.info,
           applicant:this.applicant,
           insured:this.insured
        });
        this.$axios
          .post("/app/api/zhufeng/policy", json)
          .then(res => {
            console.log(res);
            this.$router.push("/result");
            this.loading = false;
          })
          .catch(err => {
            this.$message.error(err.message);
            this.loading = false;
          });
      }
    }
  },
  created () {
    this.$axios.get("/json/fgx.json").then(data => {
       this.plan = data;
    });
    if (process.env.NODE_ENV === "development") {
      this.applicant={
        name:'君乐宝',
        email:'26347823@qq.com',
        identifyNumber:'91120103MA06J25628',
        address:'石家庄新石中路',
        postCode:'0562000',
        contactName:'琳娜',
        contantMobile:'18762374637'
      }

      this.insured = {
        name:'安慕希',
        identifyNumber:'913504287051880072',
        address:'河北省邯郸市',
        postCode:'056201',
        concatName:'安妮',
        mobile:'13748495837',
        propertyAddress:'积水潭2号',//财产地址
        businessNature:'国企',//营业性质
        industry:'计算机',//行业
        enterpriseNature:'机关'//企业性质
      }
    }
  }
};
</script>
<style lang="scss">
$form-item-left-width: 284px;
$form-item-label-width: 84px;
$label-margin-right: 20px;
$input-width: $form-item-left-width - $form-item-label-width -
  $label-margin-right;
.p-insure {
  .insure-card {
    .form-section {
      padding: 30px 137px 12px 0;
    }
    .plan-section {
      padding: 40px 0;
      .form-item {
        width: 240px !important;
        .plan-section-label {
          width: 56px;
        }
      }
    }
    .form {
      .form-item {
        label {
          width: $form-item-label-width;
          text-align: right;
        }
      }
      .form-item-left {
        width: $form-item-left-width;
        flex-grow: 0;
        .date-input {
          width: $input-width;
        }
      }
      .form-item-btn-mb {
        margin-bottom: 28px;
      }
      .form-item-btn-wrap {
        width: $input-width;
        .v-btn {
          margin: 0;
        }
      }
    }
  }
  .right-section {
    width: 330px;
    margin-left: 20px;
    .pay-card {
      margin: 0;
      width: 330px;
      padding: 50px 25px;
      font-size: 14px;
      .line {
        margin: 20px 0;
      }
      .checkbox {
        margin-top: -4px;
      }
      .pay-btn {
        margin-top: 30px;
        height: 50px;
      }
    }
  }
  .isBuy label {
    margin-top: 0 !important;
  }
  .long {
    width: 250px;
  }
  .text{
    color:rgba(0,0,0,0.54);
    font-size:14px;
    margin-top:10px;
  }
}
</style>
